/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img[_ngcontent-%COMP%]{width:60vw;height:60vh;-o-object-fit:contain;object-fit:contain}video[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto;height:23vh;width:100%;-o-object-fit:contain;object-fit:contain}.gallery-button[_ngcontent-%COMP%]{width:115px}.gallery-button-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}"];
export { styles as styles };
